export default "__VITE_ASSET__DibkYcov__"